import { gql } from '@apollo/client'

export const SetAssistant = gql`
    mutation SetAssistant($roomId: ID!, $username: String) {
        setAssistant(roomId: $roomId, username: $username) {
            id
            username
        }
    }
`

export default SetAssistant

